export default __webpack_public_path__ + "static/media/boxing-ring.e38a9ac1.png";